import { render, staticRenderFns } from "./auth_page.vue?vue&type=template&id=1a1c0b1d"
import script from "./auth_page.vue?vue&type=script&lang=js"
export * from "./auth_page.vue?vue&type=script&lang=js"
import style0 from "./auth_page.vue?vue&type=style&index=0&id=1a1c0b1d&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports